<template>
    <vs-chip :transparent="true" class="ag-grid-cell-chip" :color="chipColor(rowData.customerType)">
        <span>{{ string(rowData.customerType) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: "CellRendererCustomerStatus",
    props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
    computed: {
        chipColor() {
            return value => {
                if (value === 1) {
                    return "warning"
                } else if (value === 2) {
                    return "complete"
                } else if (value === 3) {
                    return "danger"
                } else if (value === 4) {
                    return "primary"
                } else if (value === 5) {
                    return "warning"
                } else if (value === 6) {
                    return "complete"
                } else if (value === 6) {
                    return "danger"
                }
            }
        },
        string() {
            return value => {
                if (value === 1) {
                    return "Khách hàng cũ tái khám"
                } else if (value === 2) {
                    return "Khách hàng cũ sử dụng dv"
                } else if (value === 3) {
                    return "Khách hàng cũ tư vấn dv"
                } else if (value === 4) {
                    return "Khách hàng mới tư vấn dv"
                } else if (value === 5) {
                    return "Khách hàng mua thuốc mỹ phẩm"
                } else if (value === 6) {
                    return "Khách hàng trả lại thuốc"
                } else if (value === 6) {
                    return "Khách hàng hoàn phí"
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
